import React, { PureComponent } from 'react';
import classnames from 'classnames';

const exps = [
  {
    id: '293r76!(DG@N*1d7G!',
    name: 'Contest',
  },
  {
    id: '9@YD(@8hd9!',
    name: 'Trivia',
  },
  {
    id: '9@wefpziJ$<OQFCYD(@8hd9!',
    name: 'Video',
  },
];

export class Experiences extends PureComponent {
  state = {
    sel: '293r76!(DG@N*1d7G!',
  };

  renderRow = row => {
    const isSel = this.state.sel === row.id;
    return (
      <div
        className={classnames(
          'text-sm pl-2 pr-2 pt-1 pb-1 flex justify-between cursor-pointer',
          {
            'bg-blue text-white': isSel,
          },
          {
            'text-blue hover:bg-grey hover:text-white': !isSel,
          }
        )}
        key={row.id}
      >
        <div>{row.name}</div>
        <div>x</div>
      </div>
    );
  };

  render() {
    return (
      <div className="p-4">
        <div className="flex justify-between mb-2">
          <div className="text-sm font-bold">Experiences</div>
          <div className="text-sm font-bold appearance-none cursor-pointer text-blue hover:text-blue-darker">
            +ADD
          </div>
        </div>
        <div>{exps.map(row => this.renderRow(row))}</div>
      </div>
    );
  }
}

export default Experiences;
